import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({
  title = 'RapidGoo - Business & IT Services UAE',
  description = 'RapidGoo offers comprehensive business registration, accounting, VAT filing, and IT services in the UAE. Your trusted partner for business success.',
  keywords = 'business services UAE, IT services Dubai, company registration, VAT filing, web development',
  image = '/og-image.jpg',
  url = '',
  type = 'website',
  noindex = false,
  canonical = true,
  jsonLd = null,
}) => {
  const siteUrl = 'https://rapidgoo.com';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  // og:image / twitter:image must always be absolute — resolve relative paths (e.g. the
  // default '/og-image.jpg') against siteUrl rather than emitting a relative URL.
  const fullImage = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Robots */}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      {/* SHARED CONTRACT (B9/B10, matches xivoHr's usePageMeta): canonical:false = error-page
          mode — no canonical, no og:url. Already true here (both gated on the same `canonical`
          prop) — this comment documents the cross-repo contract, no behavior change. */}
      {canonical && <meta property="og:url" content={fullUrl} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="RapidGoo" />
      <meta property="og:locale" content="en_AE" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Canonical URL — omitted when canonical=false (e.g. 404 pages: a canonical
          alongside noindex is a contradictory signal, see R2 fix F1) */}
      {canonical && <link rel="canonical" href={fullUrl} />}

      {/* JSON-LD Structured Data */}
      {jsonLd && (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEOHead;
